window.setActiveSidebar = function(params) {
  console.log(params.url)
  $("#sidebar-menu a[class='active']").each(function(idx, elm){
    $(elm).removeClass('active')
  })

  $("#sidebar-menu a[class='active subdrop']").each(function(idx, elm){
    $(elm).removeClass('active')
    $(elm).removeClass('subdrop')
  })

  if (params.dom.closest("#sidebar-menu").length == 0) {
    return true;
  }

  params.dom.addClass("active")

  const submenu = params.dom.closest(".submenu")
  if (submenu.length == 0) {
    return true;
  }

  const subdrop = submenu.find("a[class='subdrop']")
  if (subdrop.length == 0) {
    return true;
  }

  subdrop.addClass("active")
}